import { render, staticRenderFns } from "./ChatOption.vue?vue&type=template&id=2d8405f0&scoped=true&"
import script from "./ChatOption.vue?vue&type=script&lang=js&"
export * from "./ChatOption.vue?vue&type=script&lang=js&"
import style0 from "./ChatOption.vue?vue&type=style&index=0&id=2d8405f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8405f0",
  null
  
)

export default component.exports